// components/Salesinvoiceoverdue.js
import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Stack from '@mui/material/Stack';
import {  PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip} from 'recharts';
import { LineChart } from '@mui/x-charts';
import { CircularProgress } from '@mui/material';


const componentStyles = {
  rootPaper: {
    flex: '1 1 30%',
    margin: '8px',
    minWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    '& h3': {
      padding: '10px 2%',
    },
  },
  tableContainer: {
    maxHeight: 300,
    overflowY: 'auto',
  },
  table: {
    minWidth: 400,
  },
  moreLink: {
    textAlign: 'center',
    padding: '8px',
    cursor: 'pointer',
    color: '#1976d2',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tablesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    padding: '16px',
  },
  chartContainer: {
    flex: '1 1 30%',
    margin: '8px',
    minWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  chartTitle: {
    padding: '10px 2%',
    marginBottom: '10px',
  },
  chartContentWrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chartTitleRight: {
    padding: '10px 2%',
    flexGrow: 1,
    textAlign: 'right',
    marginBottom: '10px',
  },
  lineChartPaper: {
    flex: '1 1 100%',
    margin: '8px',
    minWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    height: 450,
  }
};

class DashboardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { data, columns, emptyMessage, moreLinkPath, navigate } = this.props;
    const displayedRows = Array.isArray(data) ? data.slice(0, 5) : [];
    const tableColumns = [{
      key: 'serial_number',
      render: (_, index) => `${index + 1}.`,
      width: '2px',
      sortable: false
    }, ...columns];

    return (
      <>
        <TableContainer style={componentStyles.tableContainer}>
          <Table stickyHeader aria-label="dashboard table" style={componentStyles.table}>
            <TableBody>
              {displayedRows.length > 0 ? (
                displayedRows.map((item, index) => (
                  <TableRow key={index}>
                    {tableColumns.map((col) => (
                      <TableCell
                        key={col.key}
                        style={{
                          textAlign: col.key === 'iop_total' ? 'right' : 'left',
                          padding: '4px 8px',
                          whiteSpace: 'nowrap',
                          ...(col.width ? { width: col.width } : {})
                        }}
                      >
                        {col.render ? col.render(item, index) : item[col.key]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={tableColumns.length} align="center">
                    {emptyMessage}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {Array.isArray(data) && data.length > 5 && (
          <div
            style={componentStyles.moreLink}
            onClick={() => navigate(moreLinkPath)}
          >
            Show More
          </div>
        )}
      </>
    );
  }
}

class OverdueSalesInvoiceTable extends Component {
  render() {
    const columns = [
      { key: 'sin_invoicedate', render: (item) => item.sin_invoicedate || 'N/A' },
      { key: 'cu_businessname', render: (item) => item.cu_businessname || 'N/A' },
      {
        key: 'iop_total',
        render: (item) => `$${parseFloat(item.iop_total || 0).toFixed(2)}`
      },
    ];

    return (
      <Paper style={componentStyles.rootPaper} className="dashboardpad">
	  
        <h3>Overdue Invoices</h3>
        <DashboardTable
          data={this.props.salesinvoice}
          columns={columns}
          emptyMessage="No overdue sales invoices found."
          moreLinkPath="/Adminsalesinvoice?status=7"
          navigate={this.props.navigate}
        />
		
		{this.props.salesinvoice.length>0 && (
		<div className="viewbox">
		<a  href="#/Adminsalesinvoice?overdue" target="_blank" >view</a>
		</div>
		)}
		
      </Paper>
    );
  }
}

class TopCustomersPaidTable extends Component {
  render() {
    const columns = [
      { key: 'cu_businessname', render: (item) => item.cu_businessname || 'N/A' },
      {
        key: 'iop_total',
        render: (item) => `$${parseFloat(item.iop_total || 0).toFixed(2)}`
      },
    ];

    return (
      <Paper style={componentStyles.rootPaper} className="dashboardpad">
        <h3>Top 5 Customers</h3>
        <DashboardTable
          data={this.props.topCustomersPaid}
          columns={columns}
          emptyMessage="No top customers found."
          moreLinkPath="/Adminsalesinvoice"
          navigate={this.props.navigate}
        />
      </Paper>
    );
  }
}

class TopAROutstandingTable extends Component {
  render() {
    const columns = [
      { key: 'cu_businessname', render: (item) => item.cu_businessname || 'N/A' },
      {
        key: 'iop_total',
        render: (item) => `$${parseFloat(item.iop_total || 0).toFixed(2)}`
      },
    ];

    return (
      <Paper style={componentStyles.rootPaper} className="dashboardpad">
        <h3>Top A/R Outstanding</h3>
        <DashboardTable
          data={this.props.topAROutstanding}
          columns={columns}
          emptyMessage="No top A/R outstanding found."
          moreLinkPath="/Accountsrecievablereport"
          navigate={this.props.navigate}
        />
      </Paper>
    );
  }
}

class DueOverdueCharts extends Component {
  render() {
    const { salesinvoiceOverdue } = this.props;
    const totalDueAmount = salesinvoiceOverdue.reduce((sum, invoice) => sum + parseFloat(invoice.due_amount || 0), 0);
    const totalOverdueAmount = salesinvoiceOverdue.reduce((sum, invoice) => sum + parseFloat(invoice.overdue_amount || 0), 0);
    const totalOverallAmount = totalDueAmount + totalOverdueAmount;

    const data = [
      { name: 'Due Amount', value: totalDueAmount },
      { name: 'Overdue Amount', value: totalOverdueAmount },
    ];
    const COLORS = ['orange', 'red'];

    return (
      <Paper style={componentStyles.chartContainer} className="dashboardpad">
        <h3>Outstanding Sales Invoices</h3>
        <div style={componentStyles.chartContentWrapper}>
          <ResponsiveContainer height={160}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={60}
                fill="#8884d8"
                paddingAngle={5}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => `$${value.toFixed(2)}`} />
              <Legend
                layout="vertical"
                verticalAlign="middle"
                align="right"
                wrapperStyle={componentStyles.legendStyle}
                formatter={(value, entry, index) => {
                  const amount = index === 0 ? totalDueAmount : totalOverdueAmount;
                  const percentage = totalOverallAmount > 0
                    ? ((amount / totalOverallAmount) * 100).toFixed(1)
                    : 0;
                  const title = entry.payload.name;
                  return (
                    <span style={{ color: 'black', fontWeight: 'bold' }}>
                      {title}
                      <div style={{
                        borderBottom: '1px solid black',
                        width: '100%',
                        marginTop: '2px',
                        marginBottom: '2px'
                      }}></div>
                      <span>
                        ${amount.toFixed(2)} &nbsp;&nbsp;&nbsp;{percentage}%
                      </span>
                    </span>
                  );
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Paper>
    );
  }
}

class QuotesEstimateCharts extends Component {
  render() {
    const { quotesEstimateData } = this.props;
    const { TotalWon, TotalPending, TotalExpired } = quotesEstimateData;
    const totalOverallAmount = TotalWon + TotalPending + TotalExpired;

    const data = [
      { name: 'Won', value: TotalWon },
      { name: 'Pending', value: TotalPending },
      { name: 'Expired', value: TotalExpired },
    ];
    const COLORS = ['#0088FE', '#FFA500', '#FFFF00'];

    return (
      <Paper style={componentStyles.chartContainer} className="dashboardpad">
        <h3>Quotes & Estimates</h3>
        <div style={componentStyles.chartContentWrapper}>
          <ResponsiveContainer height={160}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={60}
                fill="#8884d8"
                paddingAngle={5}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => `$${value.toFixed(2)}`} />
              <Legend
                layout="vertical"
                verticalAlign="middle"
                align="right"
                wrapperStyle={componentStyles.legendStyle}
                formatter={(value, entry, index) => {
                  const amount = entry.payload.value;
                  const percentage = totalOverallAmount > 0
                    ? ((amount / totalOverallAmount) * 100).toFixed(1)
                    : 0;
                  const title = entry.payload.name;
                  return (
                    <span style={{ color: 'black', fontWeight: 'bold' }}>
                      {title}
                      <div style={{
                        borderBottom: '1px solid black',
                        width: '100%',
                        marginTop: '2px',
                        marginBottom: '2px'
                      }}></div>
                      <span>
                        ${amount.toFixed(2)} &nbsp;&nbsp;&nbsp;{percentage}%
                      </span>
                    </span>
                  );
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Paper>
    );
  }
}

export default class Salesinvoiceoverdue extends Component {
  constructor(props) {
    super(props);
   var strdob = new Date();
var month = "";

if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}

const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

    this.state = {
      redirect: false,
      pagename: '',
      erropen: false,
      errortype: 'error',
      errormessage: '',
      salesinvoiceOverdue: [],
      topCustomersPaid: [],
      topAROutstanding: [],
      quotesEstimateData: { TotalWon: 0, TotalPending: 0, TotalExpired: 0 },
      page: 0, prevpage: 0, totaldata: 0, rowsPerPage: 5, rowsPaging: [],
      todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',
      dataarr: { labels: [], datasets: [] },
      loading: false,
      error: null,
    };
    this.SalesGraphApicall = this.SalesGraphApicall.bind(this);
    this.fromdatehandler = this.fromdatehandler.bind(this);
    this.todatehandler = this.todatehandler.bind(this);
    this.handleClickSearch = this.handleClickSearch.bind(this);
  }

  componentDidMount() {
    document.title = "Isifol Account - Sales Dashboard";
    document.body.style.backgroundColor = '#FFFFFF';
	 this.props.parentdasCallback(
            "Customer Cash Flow Forecast"
        ); 
    if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
  this.fetchAllDashboardData();	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}


  }
  
  PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=38')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.fetchAllDashboardData();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}

  handleErrorclose = () => {
    this.setState({ erropen: false });
  };

  fetchAllDashboardData = async () => {
    this.setState({ erropen: false });
    const { fromdate1, todate1 } = this.state;
    try {

      const overdueResp = await axios.get(localStorage.getItem("ISIurl")+'ajaxreports.php?action=salesinvoicedue&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'));
      this.setState({
        salesinvoiceOverdue: Array.isArray(overdueResp.data) ? overdueResp.data : [],
      });
    } catch (error) {
      console.error("Error fetching overdue sales invoices:", error);
      this.setState({
        erropen: true,
        errortype: 'error',
        errormessage: 'Failed to load overdue invoices. Please try again.',
        salesinvoiceOverdue: [],
      });
    }
    try {
      const topCustomersResp = await axios.get(localStorage.getItem("ISIurl")+'ajaxreports.php?action=salesinvoicetopcustomer&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'))
;
      this.setState({
        topCustomersPaid: Array.isArray(topCustomersResp.data) ? topCustomersResp.data : [],
      });
    } catch (error) {
      console.error("Error fetching top customers by paid amount:", error);
      this.setState({
        erropen: true,
        errortype: 'error',
        errormessage: 'Failed to load top customers. Please try again.',
        topCustomersPaid: [],
      });
    }
    try {

      const arOutstandingResp = await axios.get(localStorage.getItem("ISIurl")+'ajaxreports.php?action=salesinvoicearoutstanding&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'))
;
      this.setState({
        topAROutstanding: Array.isArray(arOutstandingResp.data) ? arOutstandingResp.data : [],
      });
    } catch (error) {
      console.error("Error fetching top A/R outstanding:", error);
      this.setState({
        erropen: true,
        errortype: 'error',
        errormessage: 'Failed to load A/R outstanding. Please try again.',
        topAROutstanding: [],
      });
    }
    try {

      const quotesResp = await axios.get(localStorage.getItem("ISIurl")+'ajaxreports.php?action=estimatequotesgetall&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'))
;
      const quotesData = Array.isArray(quotesResp.data) && quotesResp.data.length > 0 ? quotesResp.data[0] : { TotalWon: 0, TotalPending: 0, TotalExpired: 0 };
      this.setState({
        quotesEstimateData: {
          TotalWon: parseFloat(quotesData.TotalWon || 0),
          TotalPending: parseFloat(quotesData.TotalPending || 0),
          TotalExpired: parseFloat(quotesData.TotalExpired || 0)
        },
      });
    } catch (error) {
      console.error("Error fetching quotes and estimates data:", error);
      this.setState({
        erropen: true,
        errortype: 'error',
        errormessage: 'Failed to load quotes and estimates data. Please try again.',
        quotesEstimateData: { TotalWon: 0, TotalPending: 0, TotalExpired: 0 },
      });
    }
    this.SalesGraphApicall();
  }

SalesGraphApicall() {
    this.setState({ loading: true, error: null });


    axios.get(localStorage.getItem("ISIurl") + 'ajaxreports.php?action=salesinvoicegraphgetall&fromdate=' + this.state.fromdate1 + '&todate=' + this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'))
       
	   .then(response => {
            const salesReports = response.data;
            if (Array.isArray(salesReports) && salesReports.length > 0) {
                let hlabel = [];
                let salesInvoiceData = [];
                let creditNoteData = [];
                let netSalesData = [];

                for (let eachReport of salesReports) {
              
                    hlabel.push(eachReport.transaction_date);
                    salesInvoiceData.push(parseFloat(eachReport.sales_amount || 0));
                    creditNoteData.push(parseFloat(eachReport.credit_note_amount || 0));
                    netSalesData.push(parseFloat(eachReport.net_sales_amount || 0));
                }

                const datasets = [
                    {
                        label: "Sales Invoices",
                        data: salesInvoiceData,
                        borderColor: '#FF0000',
                        backgroundColor: 'rgba(75, 192, 192, 0.5)',
                        area: false,
                        showMark: false,
                    },
                    {
                        label: "Sales Credit Notes",
                        data: creditNoteData,
                        borderColor: '#00FFFF',
                        backgroundColor: 'rgba(255, 99, 132, 0.5)',
                        area: false,
                        showMark: false,
                    },
                    {
                        label: "Net Sales",
                        data: netSalesData,
                        borderColor: '#800080',
                        backgroundColor: 'rgba(54, 162, 235, 0.5)',
                        area: false,
                        showMark: false,
                    },
                ];
                const dataperformance = {
                    labels: hlabel,
                    datasets: datasets
                };
                this.setState({ dataarr: dataperformance, loading: false });
            } else {
                this.setState({ dataarr: { labels: [], datasets: [] }, loading: false });
            }
        })
        .catch(error => {
            console.error("Error fetching sales graph data:", error);
            this.setState({ error: "Failed to load sales data.", loading: false, dataarr: { labels: [], datasets: [] } });
        });
}

  fromdatehandler(date) {
    this.setState({
      fromdate: date,
      fromdate1: date ? date.format('YYYY-MM-DD') : '',
    });
  }

  todatehandler(date) {
    this.setState({
      todate: date,
      todate1: date ? date.format('YYYY-MM-DD') : '',
    });
  }

  handleClickSearch() {
    this.fetchAllDashboardData();
  }





  render() {
	  
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }
    const { dataarr, loading, error } = this.state;
    const { labels, datasets } = dataarr;
    const chartSeries = datasets.map(dataset => ({
      data: dataset.data,
      label: dataset.label,
      color: dataset.borderColor,
      area: dataset.area,
      showMark: dataset.showMark,
    }));


    return (
      <React.Fragment >
        <div className="tabbox">
         
            <Collapse in={this.state.erropen}>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={this.handleErrorclose}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                severity={this.state.errortype}
              >
               <p>  {this.state.errormessage} </p>
              </Alert>
            </Collapse>
         
        
        <div className="searchbox">
          <ul>
            <li>
              <p>From Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    value={dayjs(this.state.fromdate)}
                    className="txtbox"
                    onChange={this.fromdatehandler}
                    format="MM/DD/YYYY"
					
                  />
                </DemoContainer>
              </LocalizationProvider>
            </li>
            <li>
              <p>To Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    value={dayjs(this.state.todate)}
                    className="txtbox"
                    onChange={this.todatehandler}
                       format="MM/DD/YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </li>
            <li>
              <p>&nbsp;</p>
              <p className="searchbutton">
                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                  Calculate
                </Button>
              </p>
            </li>
          </ul>
        </div>
        <div className="clear"></div>
        {loading ? (
          <Stack justifyContent="center" alignItems="center" sx={{ height: 300 }}>
            <CircularProgress />
            <p>Loading sales data...</p>
          </Stack>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Paper sx={{ ...componentStyles.rootPaper, ...componentStyles.lineChartPaper }} className="dashboardpad">
            {loading ? (
              <Stack justifyContent="center" alignItems="center" sx={{ height: 300 }}>
                <CircularProgress />
                <p>Loading sales data...</p>
              </Stack>
    
	) : (
	
	
				<LineChart
					  xAxis={[
						{
						  id: 'xAxis',
						  scaleType: 'linear', // numeric X-axis ensures sharp segments
						  data: labels.map((_, i) => i),
						  valueFormatter: (index) => dayjs(labels[index]).format('D MMM'),
						},
					  ]}
					  yAxis={[
						{
						  id: 'linearAxis',
						  scaleType: 'linear',
						  position: 'left',
						  label: 'Amount',
						},
					  ]}
					  series={chartSeries.map((s) => ({
						yAxisId: 'linearAxis',
						data: s.data,
						label: s.label,
						line: {
						  interpolation: 'linear',  
						  strokeWidth: 2,
						  strokeColor: s.color || '#4caf50',
						  style: { strokeDasharray: '0' }, 
						  dot: {
							show: true,
							size: 6,
							fill: s.color || '#4caf50',
							stroke: '#fff',
							strokeWidth: 1,
						  },
						},
					  }))}
					  height={400}
					  margin={{ left: 60, right: 30, top: 30, bottom: 60 }}
					  skipAnimation
					  grid={{ vertical: true, horizontal: true, lineColor: '#eee', lineWidth: 5 }}
					  tooltip={{
						show: true,
						format: (value, series) => `${series.label}: ${value.toFixed(2)}`,
						backgroundColor: '#fff',
						borderColor: '#ccc',
						borderWidth: 1,
						fontSize: 12,
					  }}
				/>



            )}
          </Paper>
        )}
        <div style={componentStyles.tablesContainer}>
          <DueOverdueCharts salesinvoiceOverdue={this.state.salesinvoiceOverdue} />
          <OverdueSalesInvoiceTable salesinvoice={this.state.salesinvoiceOverdue} navigate={this.props.navigate} />
          <QuotesEstimateCharts quotesEstimateData={this.state.quotesEstimateData} />
          <TopAROutstandingTable topAROutstanding={this.state.topAROutstanding} navigate={this.props.navigate} />
          <TopCustomersPaidTable topCustomersPaid={this.state.topCustomersPaid} navigate={this.props.navigate} />
        </div>
        <div className="clear"></div></div>
      </React.Fragment>
    );
  }
}

